import * as api from '../../resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchPackStatusesDictionaryRequest = () => ({
  type: actionTypes.FETCH_PACK_STATUSES_DICTIONARY_REQUEST,
});

export const fetchPackStatusesDictionarySuccess = (packStatuses) => ({
  type: actionTypes.FETCH_PACK_STATUSES_DICTIONARY_SUCCESS,
  packStatuses,
});

export const fetchPackStatusesDictionaryFailure = () => ({
  type: actionTypes.FETCH_PACK_STATUSES_DICTIONARY_FAILURE,
});

export const fetchPackStatusesDictionary = () => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;

    dispatch(fetchPackStatusesDictionaryRequest());

    const packStatuses = await api.fetchPackStatusesDictionary({ locale });
    dispatch(fetchPackStatusesDictionarySuccess(packStatuses));
  } catch (error) {
    console.error('PACKS_STATUSES_DICTIONARY', error);
    dispatch(fetchPackStatusesDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/pack-statuses-dictionary.actions.js